// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f31736e6","732":"a699a271","977":"1223ea9f"}[chunkId] + ".chunk.js";
};